import React from "react";
import PricingPlan from "../pricing";
import { FreeType, FreeCost, FreeTime, MonthType, MonthTime, MonthCost, YearType, YearCost, YearTime } from '../../constants';

const SlideFour = () => {

    const freeData = `{"type": "${FreeType}", "cost": "${FreeCost}", "time": "${FreeTime}", "one": "Generate 5 Sub-Topics", "two": "Create Unlimited Course", "three": "Video & Theory Course", "four": "Lifetime access", "five": "Theory & Image Course", "six": "Course In 23+ Languages", "seven": "Ai Teacher Chat"}`;
    const parsedFreeData = JSON.parse(freeData);

    const monthData = `{"type": "${MonthType}", "cost": "${MonthCost}", "time": "/${MonthTime}", "one": "Generate 10 Sub-Topics", "two": "Create Unlimited Course", "three": "Video & Theory Course", "four": "1 Month Access", "five": "Theory & Image Course", "six": "Course In 23+ Languages", "seven": "Ai Teacher Chat"}`;
    const parsedMonthData = JSON.parse(monthData);

    const YearData = `{"type": "${YearType}", "cost": "${YearCost}", "time": "/${YearTime}", "one": "Generate 10 Sub-Topics", "two": "Create Unlimited Course", "three": "Video & Theory Course", "four": "1 Year Access", "five": "Theory & Image Course", "six": "Course In 23+ Languages", "seven": "Ai Teacher Chat"}`;
    const parsedYearData = JSON.parse(YearData);

    return (
        <div className="dark:bg-black py-14">
            <div className="px-11 items-start justify-start text-start">
                <div className="text-4xl max-md:text-2xl font-black dark:text-white max-md:text-center">Pricing</div>
                <p className="py-3 font-medium max-md:text-xs dark:text-white max-md:text-center">Choose the right plan for your education and future</p>
            </div>
            <div className="lg:flex py-10">

                <div className="flex flex-col items-center justify-center lg:w-1/3 max-md:pt-4">
                    <PricingPlan data={parsedFreeData} />
                </div>

                <div className="flex flex-col items-center justify-center lg:w-1/3 max-md:pt-4">
                    <PricingPlan data={parsedMonthData} />
                </div>

                <div className="flex flex-col items-center justify-center lg:w-1/3 max-md:pt-4">
                    <PricingPlan data={parsedYearData} />
                </div>
            </div>
        </div>
    );
};

export default SlideFour;
